import scene from "./Scene";
import camera from "./Camera";
import renderer from "./Rendered";
import gltfLoader from "./gltfLoader";
import { ambientalLight, pointLight } from "./Light";
import { useRef, useEffect } from "react";
import * as THREE from "three";
import { gsap } from "gsap";

const Template3D = () => {
  const mountRef = useRef(null);

  useEffect(() => {
    //Data from the canvas
    const currentRef = mountRef.current;
    const { clientWidth: width, clientHeight: height } = currentRef;

    //Scene, camera, renderer
    scene.add(camera);

    //Light
    scene.add(ambientalLight);
    scene.add(pointLight);
    camera.position.set(0, 0, 2);

    const Logo = new THREE.Group();

    //env Map para que lo metalico refleje
    const cubeTextureLoader = new THREE.CubeTextureLoader();
    const enp = cubeTextureLoader.load([
      "./envMap/px.jpg",
      "./envMap/nx.jpg",
      "./envMap/py.jpg",
      "./envMap/ny.jpg",
      "./envMap/pz.jpg",
      "./envMap/nz.jpg",
    ]);

    gltfLoader.load(
      "./Models/LogoPorfolio.gltf",
      (gltf) => {
        while (gltf.scene.children.length) {
          gltf.scene.children[0].material.envMap = enp;
          gltf.scene.children[0].material.roughness = 0.15;
          if (gltf.scene.children[0].name === 'glass') {
            gltf.scene.children[0].material.opacity = 0.01;
            gltf.scene.children[0].material.roughness = 1;
            gltf.scene.children[0].material.transparent = true;
          }
          Logo.add(gltf.scene.children[0]);
        }
        scene.add(Logo);
      }
    );
    renderer.setSize(width, height);
    currentRef.appendChild(renderer.domElement);
    renderer.setSize(currentRef.clientWidth, currentRef.clientHeight);
    camera.aspect = currentRef.clientWidth / currentRef.clientHeight;
    camera.updateProjectionMatrix();
    const resize = () => {
      renderer.setSize(currentRef.clientWidth, currentRef.clientHeight);
      camera.aspect = currentRef.clientWidth / currentRef.clientHeight;
      camera.updateProjectionMatrix();
    };
    window.addEventListener("resize", resize);
    const mouse = {
      x: 0

    };
    let validator = false;
    const animate = () => {
      renderer.render(scene, camera);
      requestAnimationFrame(animate);
      if (validator) {
        gsap.to(Logo.rotation, {
          y: mouse.x * 0.5,
          duration: 2
        });
      }
    };
    animate();
    Logo.position.y = 5;
    Logo.rotation.x = -1;
    let animation = gsap.timeline({ onComplete: () => { validator = true }, repeat: 0, yoyo: false });
    animation.to(Logo.position,
      {
        duration: 1,
        y: 0
      });
    animation.to(Logo.rotation,
      {
        duration: 3,
        x: 1.5
      });
    animation.to(Logo.rotation,
      {
        duration: 1,
        x: 0.8
      });

    document.addEventListener('mousemove', (event) => {
      mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
    });

    return () => {
      window.removeEventListener("resize", resize);
      currentRef.removeChild(renderer.domElement);
    };
  }, []);

  return (
    <div
      className='three'
      ref={mountRef}
      style={{ width: "100%", height: "200px" }}
    ></div>
  );
};
export default Template3D;



